import { useEffect } from "react";
import { getMaterialFromColor, getTilePreviewSizes } from "../Utilities/tilePreview";
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../store/loaderSlice";
import { buildBasketItemImageUrl } from "../Utilities/basketImage";

const CbImg = (props) => {
  const dispatch = useDispatch();
  const basket = useSelector((state) => state.basket.basket);

  const imageUrl = buildBasketItemImageUrl(props.item, basket);
  const material = getMaterialFromColor(props.item.frame_color);
  const { containerSize, imageSize, frameSize } = props.isTile
    ? getTilePreviewSizes(props.item.format, material)
    : { containerSize: "100%", imageSize: "100%", frameSize: "100%" };

  useEffect(() => {
    // Hide loader after component mounts
    dispatch(loaderActions.loaderHide());
  }, [dispatch]);

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        isolation: 'isolate',
      }}
    >
      {/* Inner container - sized based on format (20x20 vs 30x30) */}
      <div
        style={{
          position: 'relative',
          width: containerSize,
          height: containerSize,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Main product image (below frame) */}
        <img
          src={imageUrl}
          alt={props.item.title || 'Product'}
          style={{
            position: 'absolute',
            width: imageSize,
            height: imageSize,
            objectFit: 'cover',
            boxShadow: '3px 3px 9px #DADADA',
          }}
        />

        {/* Frame border (on top of image) */}
        {props.isTile && props.item.itemImageUrl && (
          <img
            src={props.item.itemImageUrl}
            alt=""
            style={{
              position: 'absolute',
              width: frameSize,
              height: frameSize,
              objectFit: 'contain',
            }}
          />
        )}
      </div>
    </div>
  );
};
export default CbImg;
